/* Nunito Sans. md 15/24 es el cuerpo; sm 14 la bajada de una sección; xs 12 el caption; lg 18 la bajada de un hero. */
.text {
  margin: 0;
  font-family: var(--font-body);
  font-weight: var(--fw-regular);
  line-height: var(--lh-relaxed);
  color: var(--text-body);
}
.text[data-size="xs"] {
  font-size: var(--fs-2xs);
  line-height: var(--lh-normal);
}
.text[data-size="sm"] {
  font-size: var(--fs-sm);
  line-height: 1.5;
}
.text[data-size="md"] {
  font-size: var(--fs-md);
}
.text[data-size="lg"] {
  font-size: var(--fs-lg);
}
.text[data-tone="muted"] {
  color: var(--text-muted);
}
.text[data-tone="subtle"] {
  color: var(--text-subtle);
}
.text[data-tone="strong"] {
  color: var(--text-strong);
}
.text[data-tone="brand"] {
  color: var(--text-brand);
}
.text[data-tone="accent"] {
  color: var(--text-accent);
}
.text[data-tone="inverse"] {
  color: var(--text-inverse);
}
.text[data-tone="success"] {
  color: var(--text-success);
}
.text[data-tone="warning"] {
  color: var(--text-warning);
}
.text[data-tone="danger"] {
  color: var(--text-danger);
}
.text[data-weight="medium"] {
  font-weight: var(--fw-medium);
}
.text[data-weight="semibold"] {
  font-weight: var(--fw-semibold);
}
.text[data-weight="bold"] {
  font-weight: var(--fw-bold);
}
.text[data-mono] {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
}
.text[data-truncate] {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
